import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class FollowUpService extends Service{

  protected url: string = this.dominio+"/adm/follow-up/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  updNotificacoes(elem){
    let headers = this.getHeaderLogado();

    return this.http.put(this.url+'notificacoes/', JSON.stringify(elem), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  getNotificacoes(){
    let headers = this.getHeaderLogado();

    return this.http.get(this.url+'notificacoes/', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/follow-up/follow-up.service.ts